import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import useTranslations from "hooks/useTranslations"
import DisclosureList from "components/organisms/common/DisclosureList"
import Icon from "images/pro/team-problems.svg"
import cc from "classcat"

const ConversationImage = ({ className }) => {
  const images = useStaticQuery(graphql`
    {
      conversation: file(
        relativePath: { eq: "pro/brooke-cagle--uHVRvDr7pg-unsplash.jpeg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 90, width: 600)
        }
      }
    }
  `)

  return (
    <GatsbyImage
      image={getImage(images.conversation)}
      imgStyle={{
        objectFit: "cover",
        objectPosition: "center",
      }}
      className={className}
    />
  )
}

export default function ProblemsPro(props) {
  const { proCoursesProblemsTitle, proCoursesProblemsList } = useTranslations()
  const list = proCoursesProblemsList.map((item) => ({ name: item }))

  return (
    <DisclosureList
      title={proCoursesProblemsTitle}
      list={list}
      fullHeight
      Image={ConversationImage}
      {...props}
    />
  )
}
